<template>
  <a-modal
    v-model:open="visible"
    width="420px"
    :centered="true"
    wrapClassName="xmov-form-modal"
    :after-close="onAfterClose"
    :footer="false"
  >
    <div class="flex flex-col items-center mt-[14px]">
      <div>
        <iconpark-icon name="Popupiconwarn" size="48"></iconpark-icon>
      </div>
      <div class="text-font-1 text-16 font-bold mt-[12px]">
        {{ $t('que-ren-ju-jue-shou-quan') }}
      </div>
      <div class="text-font-1 text-14 mt-[10px]">
        {{
          $t(
            'hen-bao-qian-mei-neng-zheng-de-nin-de-shou-quan-tong-yi-nin-ke-yi-xie-xia-nin-de-ju-jue-yuan-yin-fang-bian-wo-men-geng-hao-de-wei-nin-fu-wu',
          )
        }}
      </div>
      <a-textarea
        v-model:value="reason"
        class="mt-[16px] w-full area"
        :placeholder="$t('qing-shu-ru-ju-jue-yuan-yin')"
        :maxlength="1000"
        :rows="6"
        :show-count="true"
      ></a-textarea>
      <div class="mt-[30px] flex gap-[20px] justify-end">
        <a-button type="primary" ghost class="min-w-[90px]" size="large" @click="toggle">
          {{ $t('fan-hui') }}
        </a-button>
        <a-button type="primary" class="min-w-[90px]" size="large" @click="onReject">
          {{ $t('ju-jue-qian-shu') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts" setup>
import { ACCREDIT_STATUS } from '~/api/interface/auth';

const visible = ref(false);
const reason = ref();
const { $t } = useNuxtApp();

const emits = defineEmits(['submit']);

const onAfterClose = () => {};

const toggle = () => {
  visible.value = !visible.value;
};

// const open = () => {
//   visible.value = true
// }

const onReject = () => {
  emits('submit', {
    status: ACCREDIT_STATUS.REJECT,
    refuse_reason: reason.value,
  });
};

defineExpose({
  toggle,
});
</script>

<style lang="scss" scoped>
.area {
  :deep(.ant-input) {
    @apply bg-back-2;
    padding: 10px 12px;
  }
}
</style>
